function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M44.9975 0.506348C44.055 0.506348 43.2888 1.3133 43.2888 2.30587C43.2888 3.29844 44.055 4.10539 44.9975 4.10539C45.94 4.10539 46.7062 3.29844 46.7062 2.30587C46.7062 1.3133 45.94 0.506348 44.9975 0.506348Z",
  fill: "#131F29"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3368 0.560059C16.3684 0.560059 15.5808 1.38948 15.5808 2.40941C15.5808 3.42933 16.3684 4.25875 17.3368 4.25875C18.3053 4.25875 19.0928 3.42933 19.0928 2.40941C19.0928 1.38948 18.3053 0.560059 17.3368 0.560059Z",
  fill: "#131F29"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.03456 6.07007C1.06612 6.07007 0.278564 6.89949 0.278564 7.91942C0.278564 8.93934 1.06612 9.76876 2.03456 9.76876C3.00301 9.76876 3.78963 8.93934 3.78963 7.91942C3.78963 6.89949 3.00208 6.07007 2.03456 6.07007Z",
  fill: "#131F29"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.03456 11.5801C1.06612 11.5801 0.278564 12.4095 0.278564 13.4294C0.278564 14.4494 1.06612 15.2778 2.03456 15.2778C3.00301 15.2778 3.78963 14.4484 3.78963 13.4294C3.78963 12.4105 3.00208 11.5801 2.03456 11.5801Z",
  fill: "#131F29"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.2894 11.5801C16.321 11.5801 15.5334 12.4095 15.5334 13.4294C15.5334 14.4494 16.321 15.2778 17.2894 15.2778C18.2579 15.2778 19.0454 14.4484 19.0454 13.4294C19.0454 12.4105 18.2579 11.5801 17.2894 11.5801Z",
  fill: "#131F29"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3368 17.0898C16.3684 17.0898 15.5808 17.9193 15.5808 18.9392C15.5808 19.9591 16.3684 20.7885 17.3368 20.7885C18.3053 20.7885 19.0928 19.9591 19.0928 18.9392C19.0928 17.9193 18.3053 17.0898 17.3368 17.0898Z",
  fill: "#131F29"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M2.03456 22.6001C1.06612 22.6001 0.278564 23.4295 0.278564 24.4494C0.278564 25.4694 1.06612 26.2988 2.03456 26.2988C3.00301 26.2988 3.78963 25.4694 3.78963 24.4494C3.78963 23.4295 3.00208 22.6001 2.03456 22.6001Z",
  fill: "#131F29"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3018 5.67749C11.1284 5.67749 10.1738 6.68276 10.1738 7.91957C10.1738 9.15637 11.1284 10.1607 12.3018 10.1607C13.4753 10.1607 14.4298 9.1554 14.4298 7.91957C14.4298 6.68374 13.4753 5.67749 12.3018 5.67749Z",
  fill: "#131F29"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06938 5.67749C5.89593 5.67749 4.94141 6.68276 4.94141 7.91957C4.94141 9.15637 5.89593 10.1607 7.06938 10.1607C8.24283 10.1607 9.19736 9.1554 9.19736 7.91957C9.19736 6.68374 8.24283 5.67749 7.06938 5.67749Z",
  fill: "#131F29"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3018 11.1875C11.1284 11.1875 10.1738 12.1928 10.1738 13.4296C10.1738 14.6664 11.1284 15.6707 12.3018 15.6707C13.4753 15.6707 14.4298 14.6654 14.4298 13.4296C14.4298 12.1937 13.4753 11.1875 12.3018 11.1875Z",
  fill: "#131F29"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06938 11.1875C5.89593 11.1875 4.94141 12.1928 4.94141 13.4296C4.94141 14.6664 5.89593 15.6707 7.06938 15.6707C8.24283 15.6707 9.19736 14.6654 9.19736 13.4296C9.19736 12.1937 8.24283 11.1875 7.06938 11.1875Z",
  fill: "#131F29"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3018 16.6973C11.1284 16.6973 10.1738 17.7025 10.1738 18.9384C10.1738 20.1742 11.1284 21.1804 12.3018 21.1804C13.4753 21.1804 14.4298 20.1752 14.4298 18.9384C14.4298 17.7016 13.4753 16.6973 12.3018 16.6973Z",
  fill: "#131F29"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06938 16.6973C5.89593 16.6973 4.94141 17.7025 4.94141 18.9384C4.94141 20.1742 5.89593 21.1804 7.06938 21.1804C8.24283 21.1804 9.19736 20.1752 9.19736 18.9384C9.19736 17.7016 8.24283 16.6973 7.06938 16.6973Z",
  fill: "#131F29"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3018 0.16748C11.1284 0.16748 10.1738 1.17275 10.1738 2.40956C10.1738 3.64636 11.1284 4.65066 12.3018 4.65066C13.4753 4.65066 14.4298 3.64539 14.4298 2.40956C14.4298 1.17373 13.4753 0.16748 12.3018 0.16748Z",
  fill: "#131F29"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06938 0.16748C5.89593 0.16748 4.94141 1.17275 4.94141 2.40956C4.94141 3.64636 5.89593 4.65066 7.06938 4.65066C8.24283 4.65066 9.19736 3.64539 9.19736 2.40956C9.19736 1.17373 8.24283 0.16748 7.06938 0.16748Z",
  fill: "#131F29"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3018 22.207C11.1284 22.207 10.1738 23.2123 10.1738 24.4481C10.1738 25.684 11.1284 26.6902 12.3018 26.6902C13.4753 26.6902 14.4298 25.6849 14.4298 24.4481C14.4298 23.2113 13.4753 22.207 12.3018 22.207Z",
  fill: "#131F29"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M7.06938 22.207C5.89593 22.207 4.94141 23.2123 4.94141 24.4481C4.94141 25.684 5.89593 26.6902 7.06938 26.6902C8.24283 26.6902 9.19736 25.6849 9.19736 24.4481C9.19736 23.2113 8.24283 22.207 7.06938 22.207Z",
  fill: "#131F29"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M33.719 9.95776C33.719 9.17356 34.4343 8.38836 35.9538 8.38836C36.9075 8.38836 37.6824 8.67035 38.2482 9.01612C38.5755 9.20445 38.8443 9.42366 39.0827 9.64388L41.0194 7.60416C40.6921 7.22751 40.2748 6.88274 39.7677 6.59975C38.9332 6.09755 37.6521 5.56445 35.9538 5.56445C32.7057 5.56445 30.7396 7.60416 30.7396 9.95776C30.7396 15.3236 38.3371 14.0372 38.3371 16.5472C38.3371 17.5197 37.4733 18.4305 35.8043 18.4305C34.6424 18.4305 33.7786 17.9283 33.0927 17.4261C32.7057 17.1441 32.3774 16.7983 32.0793 16.3908L30.1426 18.4305C30.5296 18.9636 31.0064 19.4349 31.5731 19.8424C32.5269 20.5639 33.8969 21.2544 35.8043 21.2544C39.2606 21.2544 41.3165 19.0582 41.3165 16.5472C41.3165 11.2133 33.719 12.4678 33.719 9.95776Z",
  fill: "#131F29"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M46.497 5.87915H43.5176V20.9413H46.497V5.87915Z",
  fill: "#131F29"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M52.2852 9.95776C52.2852 9.17356 53.0004 8.38836 54.52 8.38836C55.4737 8.38836 56.2486 8.67035 56.8143 9.01612C57.1417 9.20445 57.4104 9.42366 57.6488 9.64388L59.5856 7.60416C59.2582 7.22751 58.841 6.88274 58.3339 6.59975C57.4994 6.09755 56.2183 5.56445 54.52 5.56445C51.2718 5.56445 49.3058 7.60416 49.3058 9.95776C49.3058 15.3236 56.9033 14.0372 56.9033 16.5472C56.9033 17.5197 56.0395 18.4305 54.3705 18.4305C53.2086 18.4305 52.3448 17.9283 51.6588 17.4261C51.2718 17.1441 50.9435 16.7983 50.6455 16.3908L48.7087 18.4305C49.0957 18.9636 49.5726 19.4349 50.1393 19.8424C51.093 20.5639 52.463 21.2544 54.3705 21.2544C57.8267 21.2544 59.8827 19.0582 59.8827 16.5472C59.8827 11.2133 52.2852 12.4678 52.2852 9.95776Z",
  fill: "#131F29"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M68.7358 5.56519C64.7137 5.56519 61.4363 9.01685 61.4363 13.4102C61.4363 17.8035 64.7137 21.2551 68.8853 21.2551C71.0008 21.2551 72.4607 20.5646 73.5034 19.8432C74.0995 19.4356 74.6056 18.9643 74.9936 18.4312L73.2054 16.2351C72.878 16.6426 72.4901 16.9884 72.0728 17.2704C71.3575 17.7726 70.3149 18.2748 69.0338 18.2748C66.6202 18.2748 64.8925 16.5489 64.5642 14.5092H75.5887L75.6483 14.0698C75.6786 13.7878 75.7372 13.4112 75.7372 12.9398C75.7372 8.67208 72.7872 5.56618 68.7358 5.56618V5.56519ZM64.5642 11.8408C65.1603 9.80105 66.4707 8.3891 68.7358 8.3891C70.8514 8.3891 72.1618 9.80105 72.6093 11.8408H64.5642Z",
  fill: "#131F29"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M96.8013 9.95776C96.8013 9.17356 97.5166 8.38836 99.0361 8.38836C99.9898 8.38836 100.765 8.67035 101.33 9.01612C101.658 9.20445 101.927 9.42366 102.165 9.64388L104.102 7.60416C103.774 7.22751 103.357 6.88274 102.85 6.59975C102.015 6.09755 100.734 5.56445 99.0361 5.56445C95.788 5.56445 93.8219 7.60416 93.8219 9.95776C93.8219 15.3236 101.419 14.0372 101.419 16.5472C101.419 17.5197 100.556 18.4305 98.8866 18.4305C97.7247 18.4305 96.8609 17.9283 96.1749 17.4261C95.788 17.1441 95.4596 16.7983 95.1616 16.3908L93.2249 18.4305C93.6118 18.9636 94.0887 19.4349 94.6554 19.8424C95.6091 20.5639 96.9792 21.2544 98.8866 21.2544C102.343 21.2544 104.399 19.0582 104.399 16.5472C104.399 11.2133 96.8013 12.4678 96.8013 9.95776Z",
  fill: "#131F29"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M113.277 5.56519C109.255 5.56519 105.978 9.01685 105.978 13.4102C105.978 17.8035 109.255 21.2551 113.427 21.2551C115.542 21.2551 117.002 20.5646 118.045 19.8432C118.641 19.4356 119.147 18.9643 119.535 18.4312L117.747 16.2351C117.419 16.6426 117.031 16.9884 116.614 17.2704C115.899 17.7726 114.856 18.2748 113.575 18.2748C111.161 18.2748 109.434 16.5489 109.105 14.5092H120.13L120.19 14.0698C120.22 13.7878 120.278 13.4112 120.278 12.9398C120.278 8.67208 117.328 5.56618 113.277 5.56618V5.56519ZM109.105 11.8408C109.702 9.80105 111.012 8.3891 113.277 8.3891C115.393 8.3891 116.703 9.80105 117.151 11.8408H109.105Z",
  fill: "#131F29"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M84.6074 5.55029C80.9051 5.55029 77.8936 8.72196 77.8936 12.621V21.03H80.8919V12.621C80.8919 10.4627 82.559 8.70701 84.6083 8.70701C86.6577 8.70701 88.3248 10.4627 88.3248 12.621V21.03H91.3231V12.621C91.3231 8.72196 88.3115 5.55029 84.6093 5.55029H84.6074Z",
  fill: "#131F29"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 27,
    viewBox: "0 0 121 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a8c6d5e2df53f6c55b9cc4f95f9b83be.svg";
export { ForwardRef as ReactComponent };